
            
            import { runInjectionScript } from "@clerk/astro/internal";
            await runInjectionScript({"sdkMetadata":{"version":"2.10.0","name":"@clerk/astro","environment":"production"}});